export const socialIconMap = {
  'fb_page': 'logos:facebook',
  'instagram': 'skill-icons:instagram',
  'instagram_business': 'skill-icons:instagram',
  'whatsapp': 'logos:whatsapp-icon',
  'tiktok': 'logos:tiktok-icon',
  'linkedin': 'logos:linkedin-icon',
  'twitter': 'logos:twitter',
  'youtube': 'logos:youtube-icon',
  "outlook": "vscode-icons:file-type-outlook",
  "play_store": "logos:google-play-icon"
};

export const sociairIconNameMap = {
  'fb_page': 'Facebook',
  'instagram': 'Instagram',
  'instagram_business': 'Instagram Business',
  'whatsapp': 'WhatsApp',
  'tiktok': 'TikTok',
  'linkedin': 'LinkedIn',
  'twitter': 'Twitter',
  'youtube': 'YouTube',
  "outlook": "Outlook",
  "play_store": "Google Play Store"
};